import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { shortFormattedTime } from 'shared/utils/formattedTime';

import theme from './ReconnectionPlaceholder.scss';

const propTypes = { reconnectionTimerValue: PropTypes.number };

const defaultProps = { reconnectionTimerValue: undefined };

const ReconnectionPlaceholder = ({ reconnectionTimerValue }) => (
  <div className={ theme.root }>
    <div className={ theme.reconnect }>
      <FormattedMessage
        id="conference.noConnectionPlaceholder.tryReconnect"
        defaultMessage="** Try to reconnect."
      />
    </div>

    <div className={ theme.description }>
      <FormattedMessage
        id="conference.noConnectionPlaceholder.disconnectedConsultation"
        defaultMessage="** Consultation has been disconnected."
      />
      <br />
      <FormattedMessage
        id="conference.noConnectionPlaceholder.waitForReconnection"
        defaultMessage="** Please hold while we reconnect you."
      />
    </div>

    <div>
      <div className={ theme.loader } />
    </div>

    <div className={ theme.countDown }>
      <FormattedMessage
        id="conference.noConnectionPlaceholder.endingConsultation"
        defaultMessage="** Ending consultation in "
      />

      &nbsp;

      { shortFormattedTime(reconnectionTimerValue) }

    </div>
  </div>
);

ReconnectionPlaceholder.propTypes = propTypes;
ReconnectionPlaceholder.defaultProps = defaultProps;

export default ReconnectionPlaceholder;
